module.exports = __webpack_public_path__ + "images/title_down_arrow6d78ba83fa42421b63ee012b4fee3ad5.svg";